<template>
  <div class="content" :style="{ backgroundColor: bgColor }" @touchmove.prevent>
    <Header :title="title" :bgColor="bgColor" @toBack="toBack"></Header>
    <div
      :class="{
        box: true,
        box2: detectBrowser(),
        box3: step == 2,
      }"
    >
      <div class="title" v-if="step == 1">请选择您需要登录的Feemoo账号</div>
      <div class="accBox" v-if="step == 1">
        <div
          class="acc"
          v-for="(item, index) in accountList"
          :key="index"
          @touchmove.stop
          @click="handleSelect(item, index)"
        >
          <div class="boxA">
            <img :src="item.logo" class="logo" />
            <div class="right">
              <div class="nameBox">
                <span class="font1">{{ item.username }}</span>
                <span class="tag">{{ item.logintp_text }}</span>
              </div>
              <span class="font2">{{ item.last_login_time }}</span>
            </div>
          </div>
          <svg-btn
            class="check"
            :icon-class="
              selectUsername == index ? 'icon-short-hyes' : 'icon-short-hno'
            "
          />
        </div>
        <div style="width: 100%; min-height: 60px"></div>
      </div>
      <fm-button
        v-if="step == 1"
        class="loginBt"
        type="primary"
        round
        size="medium"
        @click="checkAccount"
        >确定</fm-button
      >
      <div class="step2" v-if="step == 2">
        <img class="logo" :src="selectUser.logo" />
        <div class="name">{{ selectUser.username }}</div>
        <FmInput
          v-model="password"
          class="loginInput"
          placeholder="请输入密码"
          type="password"
          clearable
        ></FmInput>
        <fm-button
          class="loginBt2"
          type="primary"
          round
          size="medium"
          :disabled="password.trim().length < 6"
          @click="toLogin"
          >确定</fm-button
        >
      </div>
    </div>
    <SafeDialog @onConfirm="onConfirm" ref="MyDialog" />
    <BrowserRestrict ref="BrowserRestrictRef"></BrowserRestrict>
  </div>
</template>

<script>
import { loginAPI, LoginSSOAPI, limitationDelAPI } from '@/axios/login'
import Header from '@/components/NavTopLogin/index.vue'
import SafeDialog from '@/components/Dialog/SafeDialog.vue'
import BrowserRestrict from '@/components/Dialog/BrowserRestrict'
export default {
  components: {
    Header,
    SafeDialog,
    BrowserRestrict,
  },
  data() {
    return {
      step: 1,
      selectUsername: 0,
      accountList: [],
      selectUser: {},
      password: '',
      title: '选择登录账号',
      bgColor: '#F3F5F7',
      loginTip: {
        pre: '',
        now: '',
        access_token: '',
      },
    }
  },
  watch: {
    deviceClass() {
      if (this.deviceClass == 'pc') {
        window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
      }
    },
  },
  created() {
    if (this.deviceClass == 'pc') {
      window.location.replace(`${this.$glb.feemooUrl}/login?path=drive`)
    }
    let arr = this.$store.state.accountList
    if (arr && arr.length > 0) {
      this.selectUsername = 0
      this.accountList = arr
      this.selectUser = this.accountList?.[this.selectUsername]
    } else {
      this.$router.push({ path: '/login' })
    }
  },
  mounted() {},
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
    isSafari() {
      const userAgent = navigator.userAgent.toLowerCase()
      const vendor = navigator.vendor ? navigator.vendor.toLowerCase() : ''
      const platform = navigator.platform
        ? navigator.platform.toLowerCase()
        : ''

      // 检测是否为iOS设备
      const isIOS = /iphone|ipad|ipod/.test(platform)

      // 检测是否为Safari
      // 关键改进：结合vendor和platform进行判断
      const isSafari =
        // Safari的vendor是Apple Computer, Inc.
        vendor.includes('apple') &&
        // 用户代理包含safari
        userAgent.includes('safari') &&
        // 排除Chrome和其他浏览器
        !userAgent.includes('chrome') &&
        !userAgent.includes('crios') && // Chrome for iOS
        !userAgent.includes('fxios') // Firefox for iOS

      // 检测是否为浏览器模拟模式
      const isSimulator =
        // 检测到移动设备特征但不是真实移动平台
        (/mobile|iphone|ipad|ipod|android/.test(userAgent) ||
          window.innerWidth < 768) &&
        ![
          'iphone',
          'ipad',
          'ipod',
          'android',
          'linux armv7l',
          'linux aarch64',
        ].includes(platform)

      return {
        isSafari: isSafari && !isSimulator, // 真实Safari且非模拟环境
        isIOS: isIOS,
        isSimulator: isSimulator,
        userAgent: userAgent,
        platform: platform,
      }
    },
  },
  methods: {
    checkAccount() {
      this.step = 2
      this.title = '登录账号'
      this.bgColor = '#FFFFFF'
    },
    toBack() {
      if (this.step == 1) {
        this.$router.replace({ path: '/login' })
      } else {
        this.title = '选择登录账号'
        this.bgColor = '#F3F5F7'
        this.step = 1
      }
    },
    handleSelect(item, index) {
      this.selectUser = item
      this.selectUsername = index
    },
    loginFetch(token) {
      LoginSSOAPI({ token }).then(res => {
        if (res.status == 1) {
          localStorage.setItem('shortToken', res.data.authtoken)
        }
      })
    },
    toLogin: _.debounce(
      function (captcha_verify, validate = {}) {
        return new Promise(resolve => {
          if (validate == 'close') {
            return
          }
          let username = this.selectUser?.username
          let user_id = this.selectUser?.user_id
          let logintp = this.selectUser?.logintp
          let data = {
            lot_number: validate?.lot_number || '',
            captcha_output: validate?.captcha_output || '',
            pass_token: validate?.pass_token || '',
            gen_time: validate?.gen_time || '',
            username: username,
            password: this.password,
            logintp: logintp,
            user_id: user_id,
            captcha_verify: captcha_verify || '',
          }
          loginAPI(data)
            .then(res => {
              if (res.status == 1) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.loginFetch(res.data.sso[0]?.token)
                setTimeout(() => {
                  this.toComplete()
                }, 600)
              } else if (res.status == 1011) {
                resolve({
                  result: true,
                  validate: true,
                })
                //在滑块消失后展示弹窗设定600毫秒的延时器
                setTimeout(() => {
                  if (res.data.type == 1) {
                    this.showLimitLogin(res.data)
                  } else {
                    this.showBrowserRestrict(res.data)
                  }
                }, 600)

                return
              } else if (res.status == 4000) {
                resolve({
                  result: true,
                  validate: true,
                })
                this.$htoast(res.msg)
                return
              } else if (res.status == 90001) {
                this.$htoast(res.msg)
                this.$AliCode.handleOpen(this.toLogin)
              } else if (res.status == 90002) {
                this.$utils.initgt4(
                  '5b0562a75492b420626b745b229e83a4',
                  this.toLogin
                )
              } else {
                resolve({
                  result: true,
                  validate: false,
                })
                this.$htoast(res.msg)
              }
            })
            .catch(err => {})
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    showLimitLogin(data) {
      this.loginTip.pre = data.last_province
      this.loginTip.now = data.current_province
      this.loginTip.access_token = data.access_token
      this.$refs.MyDialog.show(data)
    },
    onConfirm: _.debounce(
      function () {
        this.$refs.MyDialog.close()
        limitationDelAPI({
          access_token: this.loginTip.access_token,
        })
          .then(res => {
            if (res.status == 1) {
              this.loginFetch(res.data.sso[0]?.token)
              setTimeout(() => {
                this.toComplete()
              }, 600)
            } else {
              this.$htoast(res.msg)
            }
          })
          .catch(err => {})
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    showBrowserRestrict: _.debounce(
      function (data) {
        this.$refs.BrowserRestrictRef.handleOpen(data)
      },
      50,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    goNextBrowser(data) {
      //弃用了 现在删除完常用登录地点后 不会自动登录 还需要用户手动点击
      return
      if (data != '') {
        this.loginFetch(data.sso[0]?.token)
      }
      setTimeout(() => {
        this.toComplete()
      }, 600)
    },
    toComplete() {
      let fshort = sessionStorage.getItem('shortFshort')
      if (fshort) {
        this.$router.replace({ path: '/d/' + fshort })
      } else {
        this.$router.replace({ path: '/' })
      }
    },
    // 浏览器检测函数
    detectBrowser() {
      const userAgent = navigator.userAgent.toLowerCase()
      const vendor = navigator.vendor ? navigator.vendor.toLowerCase() : ''
      // 检测是否为Safari
      // 关键改进：结合vendor和platform进行判断
      const isSafari =
        // Safari的vendor是Apple Computer, Inc.
        vendor.includes('apple') &&
        // 用户代理包含safari
        userAgent.includes('safari') &&
        // 排除Chrome和其他浏览器
        !userAgent.includes('chrome') &&
        !userAgent.includes('crios') && // Chrome for iOS
        !userAgent.includes('fxios') // Firefox for iOS

      return isSafari
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  background: #f3f5f7;
  overflow: auto;
  height: 100%;
  overflow-x: hidden;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    display: none;
  }
  &::-webkit-scrollbar-track {
    display: none;
  }
  .box {
    display: flex;
    flex-direction: column;
    height: calc(100% - 44px);
    padding: 40px 16px 0 16px;
    .title {
      font-weight: 400;
      font-size: 14px;
      color: #2c2c2c;
      line-height: 20px;
      margin-bottom: 20px;
      margin-left: 18px;
    }
    .accBox {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      // height: calc(100% - 88px);
      flex: 1;
      .acc {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        border-radius: 16px;
        padding: 20px 16px;
        margin-bottom: 12px;
        .boxA {
          display: flex;
          align-items: center;
          flex: 1;
          .logo {
            width: 46px;
            height: 46px;
            object-fit: cover;
            margin-right: 12px;
            border-radius: 50%;
          }
          .right {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .nameBox {
              display: flex;
              align-items: center;
              margin-bottom: 4px;
              .font1 {
                @include multiline(1);
                font-weight: 500;
                font-size: 16px;
                color: #2c2c2c;
                line-height: 24px;

                margin-right: 9px;
              }
              .tag {
                background: #fff2ec;
                border-radius: 8px;
                padding: 1px 6px;
                font-weight: 400;
                font-size: 10px;
                color: #f67942;
                line-height: 14px;
                flex-shrink: 0;
              }
            }
            .font2 {
              font-weight: 400;
              font-size: 12px;
              color: #8a8b92;
              line-height: 18px;
            }
          }
        }
        .check {
          width: 20px;
          height: 20px;
          margin-left: 12px;
        }
      }
    }
    .loginBt {
      width: calc(100% - 32px);
      height: 48px;
      border-radius: 48px;
      position: fixed;
      bottom: 16px;
      span {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }
    }
    .step2 {
      width: 100%;
      height: 100%;
      margin-top: 48px;
      display: flex;
      align-items: center;
      flex-direction: column;
      .logo {
        width: 78px;
        height: 78px;
        object-fit: cover;
        border-radius: 50%;
        margin-bottom: 20px;
      }
      .name {
        font-weight: 500;
        font-size: 20px;
        color: #2c2c2c;
        line-height: 27px;
        max-width: 305px;
        text-align: center;
        margin-bottom: 33px;
        @include multiline(2);
      }
    }
    .loginBt2 {
      width: 100%;
      height: 48px;
      border-radius: 48px;
      margin-top: 24px;
      span {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }
  .box2 {
    padding-bottom: 80px;
  }
  .box3 {
    padding-right: 34px;
    padding-left: 34px;
  }
}
</style>
